
import { useEffect, useState } from 'react';
import { COUPON_TYPE, DEPOSITE_TYPE, useStyles, yesNoList, statusList_2 } from '../../constant/constant.js';
import { Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography, Box } from '@mui/material';
import { apiBaseUrl } from '../../constant/endpoint.js';
import { axiosRequest } from '../../utility/axios.js';
import { useSelector } from 'react-redux';
import CustomizedButtons from '../../components/button/button.js';

import InputTextField from '../../components/textBox/borderTextField.js';
import { InputLabel } from '@mui/material';
import { TextField } from '@mui/material';
import SelectTextFields from '../../components/customDropDown/dropDown.js';
import SelectDropDown from '../../components/customDropDown/customDropDown.js';
import DateTimePicker from '../../components/datePicker/dateTimePicker';
import { isEmpty } from 'lodash';
import { getSweetAlert } from '../../helper/index.js';
import { useNavigate } from "react-router-dom";
import { Heading, MainBox } from '../admin/subAdmin.js';

const AddPaymentOffer = () => {
    const [paymentOffer, setPaymentOffer] = useState({});
    const [disable, setDisable] = useState(true);

    const loginSlice = useSelector(state => state.loginSlice);
    const token = loginSlice.token;
    const navigate = useNavigate();

    const validateForm = () => {
        let status = true;
       
        if (isEmpty(paymentOffer.is_public)) {
            status = false;
            getSweetAlert('error', 'Enter the is public value');
        } else if (paymentOffer.first_deposite != 0 &&  paymentOffer.first_deposite != 1) {
            status = false;
            getSweetAlert('error', 'Enter a valid is first deposit value');
        } else if (isEmpty(paymentOffer.coupon_type)) {
            status = false;
            getSweetAlert('error', 'Enter the coupon type value');
        } else if (isEmpty(paymentOffer.deposite_type)) {
            status = false;
            getSweetAlert('error', 'Enter the deposite type value');
        } else if (isEmpty(paymentOffer.coupon_code) || (paymentOffer.coupon_code).length <= 2) {
            status = false;
            getSweetAlert('error', 'Enter the coupon code min 3 ');
        } else if (!paymentOffer.min_amount) {
            status = false;
            getSweetAlert('error', 'Enter the min amount');
        } else if (!paymentOffer.max_cashback_amount) {
            status = false;
            getSweetAlert('error', 'Enter the max cashback amount');
        } else if (!paymentOffer.max_cashback_percent) {
            status = false;
            getSweetAlert('error', 'Enter the max cashback percent');
        } else if (isEmpty(paymentOffer.unlimited_usage_limit)) {
            status = false;
            getSweetAlert('error', 'Enter the usage limit');
        } else if (
            paymentOffer.unlimited_usage_limit === 'no' &&
            isEmpty(paymentOffer.usage_limit)
        ) {
            status = false;
            getSweetAlert('error', 'Enter the usage limit');
        } else if (isEmpty(paymentOffer.per_user_limit)) {
            status = false;
            getSweetAlert('error', 'Enter the per user limit');
        } else if (isEmpty(paymentOffer.expiry_date)) {
            status = false;
            getSweetAlert('error', 'Enter the expiry date');
        }  else if (paymentOffer.status != 0 &&  paymentOffer.status != 1) {
            status = false;
            getSweetAlert('error', 'Enter the status');
        }
    
        return status;
    };
    

    const handleSubmit = async () => {
        if (!validateForm()) return;
        if(paymentOffer.unlimited_usage_limit == "yes"){
            paymentOffer["usage_limit"] = "unlimited";
        };
        const url = `/paymentOffer/create`;
        const res = await axiosRequest("POST", url, token, paymentOffer);

        if (res?.status === "success") {
            setPaymentOffer(res.data);
            getSweetAlert("success", "Successfully Add Offer");
            navigate("/payment-offer")
        }
    }

    const handleDateChange = (date, key) => {
        setPaymentOffer((prevState) => ({
            ...prevState,
            [key]: date
        }));
    };

    const handleChange = (event) => {
        let { name, value } = event.target;
        if (name == "coupon_code") {
            value = value.toUpperCase().replace(/[^\w\d]/g, ""); 
            if( value.length <= 8){
                setPaymentOffer(prevState => ({
                    ...prevState,
                    [name]: value
                }));
            }
        } else {
            const limits = {

                min_amount: [1, 50000],
                max_cashback_amount: [1, 50000],
                max_cashback_percent: [1, 500],
                usage_limit: [1, 100000],
                per_user_limit: [1, 100000],
                sequence: [1, 10000],
                max_amount: [0, 50000],
                
            };
        
            if (limits[name]) {
                // console.log("value",value);
                value = value == 0 || value == "-" ? "" : value;
                console.log("value",value);
                if (value == "" || (value >= limits[name][0] && value <= limits[name][1])) {
                    console.log("value --> ",value);
                    setPaymentOffer(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                return;
            }
           
        }
        
       
    };

    const handleDropDown = (name, value, _id) => {
        console.log("name",name, "_id, ", _id);
        if(name == "unlimited_usage_limit" && _id == 1){
            setDisable(true);
            console.log("calling if");
        } else if(name == "unlimited_usage_limit" && _id == 0){
            setDisable(false);
            console.log("calling else");
        };
        setPaymentOffer(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    

    useEffect(() => {

    }, []);

    return (
        <Box sx={{ width: '100%', typography: 'body1', marginTop: "100px" }}>
            <MainBox>
                <Heading fontSize={"26px"} fontWeight={"600"} textAlign={"center"}>*All fields are required</Heading>

                <Grid container spacing={2} mt={1}>
                <Grid item lg={6} xs={12}>
                         <SelectDropDown
                            label="Is Public"
                            name="is_public"
                            value={paymentOffer.is_public || ''}
                            handleOnChange={handleDropDown}
                            list={yesNoList}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                         <SelectDropDown
                            label="First Deposite"
                            name="first_deposite"
                            value={paymentOffer.first_deposite}
                            handleOnChange={handleDropDown}
                            list={statusList_2}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <SelectDropDown
                            label="Coupon Type"
                            name="coupon_type"
                            value={paymentOffer.coupon_type || ''}
                            handleOnChange={handleDropDown}
                            list={COUPON_TYPE}
                        />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                        <SelectDropDown
                            label="Deposite Type"
                            name="deposite_type"
                            value={paymentOffer.deposite_type || ''}
                            handleOnChange={handleDropDown}
                            list={DEPOSITE_TYPE}
                        />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Enter min 3 max 8 Digit Coupon Type"
                            onChange={handleChange}
                            value={paymentOffer?.coupon_code}
                            name={"coupon_code"}
                        />
                    </Grid>

                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Minimum Amount (INR)"
                            onChange={handleChange}
                            value={paymentOffer?.min_amount}
                            name={"min_amount"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Maximum Amount (INR)"
                            onChange={handleChange}
                            value={paymentOffer?.max_amount}
                            name={"max_amount"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Maximum Cashback Amount (INR)"
                            onChange={handleChange}
                            value={paymentOffer?.max_cashback_amount}
                            name={"max_cashback_amount"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Cashback Percentage (%)"
                            onChange={handleChange}
                            value={paymentOffer?.max_cashback_percent}
                            name={"max_cashback_percent"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                         <SelectDropDown
                            label="Unlimited Usage Limit"
                            name="unlimited_usage_limit"
                            value={paymentOffer.unlimited_usage_limit || ''}
                            handleOnChange={handleDropDown}
                            list={yesNoList}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Usage Limit"
                            disabled={disable}
                            onChange={handleChange}
                            value={paymentOffer?.usage_limit}
                            name={"usage_limit"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Limit Per User"
                            onChange={handleChange}
                            value={paymentOffer?.per_user_limit}
                            name={"per_user_limit"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <DateTimePicker label="Expires On"  name={'expiry_date'} value={paymentOffer?.expiry_date} handleOnChange={(date) => handleDateChange(date, "expiry_date")} />
                    </Grid>
                    {/* <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="text"
                            label="Description"
                            onChange={handleChange}
                            value={paymentOffer?.description}
                            name={"description"}
                        /> sequence
                    </Grid> */}
                    <Grid item lg={6} xs={12}>
                        <InputTextField
                            type="Number"
                            label="Sequence"
                            // disabled={disable}
                            onChange={handleChange}
                            value={paymentOffer?.sequence}
                            name={"sequence"}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                         <SelectDropDown
                            label="Status"
                            name="status"
                            value={paymentOffer.status}
                            handleOnChange={handleDropDown}
                            list={statusList_2}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <CustomizedButtons color="success" label="Create Offer" variant={"contained"} onClick={handleSubmit} />
                    </Grid>

                </Grid>
            </MainBox>
        </Box>

    );
}


export default AddPaymentOffer;
